module.exports = __webpack_public_path__ + "img/weather-1.15c4dfdf.png";